import { label } from "three/examples/jsm/nodes/Nodes.js";
import {
  blackImg,
  blueImg,
  highlightFirstVideo,
  highlightFourthVideo,
  highlightSecondVideo,
  highlightThirdVideo,
  whiteImg,
  yellowImg,
} from "../utils";

export const navLists = [
  {
    label:"回到顶部",
    value:'hero'
  },
  {
    label: "算法能力",
    value:'highlights'
  },
  {
    label:"演示视频",
    value:'videoShow'
  },
  {
    label:"外观展示",
    value:'model'
  },
  {
    label:"联系我们",
    value:'footer'
  },
];

export const hightlightsSlides = [
  {
    id: 1,
    textLists: [
      "安全帽识别"
    ],
    video: highlightFirstVideo,
    videoDuration: 4,
  },
  {
    id: 2,
    textLists: ["工服识别"],
    video: highlightSecondVideo,
    videoDuration: 5,
  },
  {
    id: 3,
    textLists: ["工裤识别"],
    video: highlightThirdVideo,
    videoDuration: 3.63,
  },
  // {
  //   id: 4,
  //   textLists: [
  //     "抽烟识别",
  //   ],
  //   video: highlightThirdVideo,
  //   videoDuration: 2,
  // },
];

export const models = [
  {
    id: 1,
    title: "iPhone 15 Pro in Natural Titanium",
    color: ["#8F8A81", "#ffe7b9", "#6f6c64"],
    img: yellowImg,
  },
  {
    id: 2,
    title: "iPhone 15 Pro in Blue Titanium",
    color: ["#53596E", "#6395ff", "#21242e"],
    img: blueImg,
  },
  {
    id: 3,
    title: "iPhone 15 Pro in White Titanium",
    color: ["#C9C8C2", "#ffffff", "#C9C8C2"],
    img: whiteImg,
  },
  {
    id: 4,
    title: "iPhone 15 Pro in Black Titanium",
    color: ["#454749", "#3b3b3b", "#181819"],
    img: blackImg,
  },
];

export const sizes = [
  { label: '6.1"', value: "small" },
  { label: '6.7"', value: "large" },
];

export const footerLinks = [
  "Privacy Policy",
  "Terms of Use",
  "Sales Policy",
  "Legal",
  "Site Map",
];